import { connect } from 'react-redux';
import GroupCompanyRegisterDashboard from '../components/GroupCompanyRegisterDashboard';

import {
    queryGroupCompanyRegister,
    initQueryGroupCompanyRegisterActionStatus,
    groupCompanyRegisterQueryChangeInput,
    selectGroupCompanyRegister,
    openGroupCompanyRegisterDetailDialog,
    resetGroupCompanyRegisterDetailDialog,
    openAddOrEditGroupCompanyRegisterModal,
    resetAddOrEditGroupCompanyRegisterModal,
    addOrEditGroupCompanyRegisterChangeInput,
    submitAddGroupCompanyRegister,
    initSubmitAddGroupCompanyRegisterActionStatus,
    submitUpdateGroupCompanyRegister,
    initSubmitUpdateGroupCompanyRegisterActionStatus,
    openDelGroupCompanyRegisterModal,
    resetDelGroupCompanyRegisterModal,
    submitDelGroupCompanyRegister,
    initSubmitDelGroupCompanyRegisterActionStatus,
} from '../GroupCompanyRegisterActions';

import { doOperationRecordAction } from '../../../common/operationRcd/OperationRecordActions';

const mapStateToProps = state => {
    return {
        queryFields: state.groupCompanyRegister.queryFields,
        queryGroupCompanyRegisterStatus: state.groupCompanyRegister.queryGroupCompanyRegisterStatus,
        queryGroupCompanyRegisterResp: state.groupCompanyRegister.queryGroupCompanyRegisterResp,
        selectedGroupCompanyRegisterArray: state.groupCompanyRegister.selectedGroupCompanyRegisterArray,
        groupCompanyRegisterUploadUrl: state.groupCompanyRegister.groupCompanyRegisterUploadUrl,
        groupCompanyRegisterDownloadUrl: state.groupCompanyRegister.groupCompanyRegisterDownloadUrl,
        groupCompanyRegisterDetailDialog: state.groupCompanyRegister.groupCompanyRegisterDetailDialog,
        groupCompanyRegisterModal: state.groupCompanyRegister.groupCompanyRegisterModal,
        submitAddGroupCompanyRegisterStatus: state.groupCompanyRegister.submitAddGroupCompanyRegisterStatus,
        submitUpdateGroupCompanyRegisterStatus: state.groupCompanyRegister.submitUpdateGroupCompanyRegisterStatus,
        delGroupCompanyRegisterModal: state.groupCompanyRegister.delGroupCompanyRegisterModal,
        submitDelGroupCompanyRegisterStatus: state.groupCompanyRegister.submitDelGroupCompanyRegisterStatus,
        operationRecord: state.operationRecord,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        queryGroupCompanyRegister: () => dispatch(queryGroupCompanyRegister()),
        initQueryGroupCompanyRegisterActionStatus: () => dispatch(initQueryGroupCompanyRegisterActionStatus()),
        groupCompanyRegisterQueryChangeInput: input => dispatch(groupCompanyRegisterQueryChangeInput(input)),
        selectGroupCompanyRegister: array => dispatch(selectGroupCompanyRegister(array)),
        openGroupCompanyRegisterDetailDialog: data => dispatch(openGroupCompanyRegisterDetailDialog(data)),
        resetGroupCompanyRegisterDetailDialog: () => dispatch(resetGroupCompanyRegisterDetailDialog()),
        openAddOrEditGroupCompanyRegisterModal: (mode, data) => dispatch(openAddOrEditGroupCompanyRegisterModal(mode, data)),
        resetAddOrEditGroupCompanyRegisterModal: () => dispatch(resetAddOrEditGroupCompanyRegisterModal()),
        addOrEditGroupCompanyRegisterChangeInput: input => dispatch(addOrEditGroupCompanyRegisterChangeInput(input)),
        submitAddGroupCompanyRegister: data => dispatch(submitAddGroupCompanyRegister(data)),
        initSubmitAddGroupCompanyRegisterActionStatus: () => dispatch(initSubmitAddGroupCompanyRegisterActionStatus()),
        submitUpdateGroupCompanyRegister: data => dispatch(submitUpdateGroupCompanyRegister(data)),
        initSubmitUpdateGroupCompanyRegisterActionStatus: () => dispatch(initSubmitUpdateGroupCompanyRegisterActionStatus()),
        openDelGroupCompanyRegisterModal: data => dispatch(openDelGroupCompanyRegisterModal(data)),
        resetDelGroupCompanyRegisterModal: () => dispatch(resetDelGroupCompanyRegisterModal()),
        submitDelGroupCompanyRegister: data => dispatch(submitDelGroupCompanyRegister(data)),
        initSubmitDelGroupCompanyRegisterActionStatus: () => dispatch(initSubmitDelGroupCompanyRegisterActionStatus()),
        doOperationRecordAction: params => dispatch(doOperationRecordAction(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GroupCompanyRegisterDashboard);
